import { useDispatch, useSelector } from 'react-redux'
import ConfirmModal from '../../../components/ConfirmModalV2'
import { setPriceAdjustDialog, setPriceAdjustExitConfirmation } from '../../ActionCreators'
import { getPriceAdjustExitConfirmation } from '../../Selectors'
import { APPLICATION_STRINGS } from '../../../strings'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'

const VNPriceAdjustExitConfirmation = () => {
  const dispatch = useDispatch()
  const history = useHistory()

  const dialogProps = useSelector(getPriceAdjustExitConfirmation)
  const isOpen = dialogProps.get('open')
  const fromViewItemDetail = dialogProps.get('fromViewItemDetail')
  const closeVNViewItemDetail = dialogProps.get('closeVNViewItemDetail')

  const { PRICE_ADJUST_EXIT_CONFIRMATION, YES_CONTINUE, NO_NEVERMIND } = APPLICATION_STRINGS

  if (!isOpen) {
    return null
  }

  return (
    <ConfirmModal
      onButtonOneClick={() => {
        dispatch(setPriceAdjustExitConfirmation(false))
      }}
      onButtonTwoClick={() => {
        dispatch(setPriceAdjustExitConfirmation(false))
        dispatch(setPriceAdjustDialog(false))

        if (!fromViewItemDetail) {
          history.goBack()
          return
        }
        //if modal is displayed from the VNViewItemDetail component we need to close that component
        closeVNViewItemDetail()
      }}
      headerText={PRICE_ADJUST_EXIT_CONFIRMATION}
      buttonOneText={NO_NEVERMIND}
      buttonTwoText={YES_CONTINUE}
      opaque={false}
    />
  )
}

export default VNPriceAdjustExitConfirmation
